const asyncMap = async <T, U>(array: T[], fn: (item: T) => U): Promise<Array<U>> => {
    const results: Array<U> = [];

    for (const item of array) {
        // push the item
        results.push(fn(item));

        // await the next tick
        // this is a trick to avoid freezing the UI thread
        // eslint-disable-next-line no-await-in-loop
        await new Promise(resolve => {
            setTimeout(resolve, 0);
        });
    }

    return results;
};

export default asyncMap;
